import { render, staticRenderFns } from "./CoozzyRejectIcon.vue?vue&type=template&id=bd294d60&scoped=true"
import script from "./CoozzyRejectIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyRejectIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyRejectIcon.vue?vue&type=style&index=0&id=bd294d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd294d60",
  null
  
)

export default component.exports